
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCallIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 21,
  height: 20,
  textRendering: "geometricPrecision",
  viewBox: "0 0 21 20"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAA7VBMVEVMaXHkAonjAofjBov/VarlA4rmA4nnCIfjB4rlAojkDZTkAojkAojlB4n/gP/kAojkA4jkAonpCIfkAojkAojkAofkAojjA4jkA4fkAojjA4rjAojkAojkAofnBojjAojkAofkAofkA4jkAofjA4nlAojnDJLlA4nmA4fjAojlA4jjA4fmGpnkA4fjAofjA4fkCYnjA4njBIfoBoj////kBInkA4jkBIfmBYrjA4fjAof/IJ/kBIjlCY3lA4nmCYjxDo7jA4jlA4fkA4fpB4rkAof/M5njAofkA4jjA4jlAojkBIjjA4flBIjjAofdlZfhAAAATnRSTlMAcNMuA1dbICV2E9/pJwL8nn0i/tb7za7Ezkrn8uwr+ODoxf2bfhVjZPZNpgpg21McUoAtAUO6hDLC9wiNHWEeEsliyCPzBXe+nHSFyoe2/a9bAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAA50lEQVR42k2R53bCMAyFLxBI2HuPQMJuCy3QPWiZnXr/x6lsJ3H05159R8eyJECGVWy07YEzsqAjVciTCnc49mEsTTr6PQXNjE+O50+irilgrhnU7XDaE9UMptMA1jlrsV6xRgO65GzLWgGyutHiAXgVpoR4qP89cCM0gaSG1WugLkwEEU1XwLosTBIJRZ6I7gxsHmUSR0nqx3Pr4hL+c1mgwtI5yClvqxJG2b6xfks4n6nSCXuDJ/5hfX8pK1jLye10iX7/vjreTzKmWlqvH5okHfMXPB66HssXUqFrWCNnYLcbRe9C/zSHSoQULJqsAAAAAElFTkSuQmCC",
  width: 21,
  height: 20,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAA7VBMVEVMaXHkAonjAofjBov/VarlA4rmA4nnCIfjB4rlAojkDZTkAojkAojlB4n/gP/kAojkA4jkAonpCIfkAojkAojkAofkAojjA4jkA4fkAojjA4rjAojkAojkAofnBojjAojkAofkAofkA4jkAofjA4nlAojnDJLlA4nmA4fjAojlA4jjA4fmGpnkA4fjAofjA4fkCYnjA4njBIfoBoj////kBInkA4jkBIfmBYrjA4fjAof/IJ/kBIjlCY3lA4nmCYjxDo7jA4jlA4fkA4fpB4rkAof/M5njAofkA4jjA4jlAojkBIjjA4flBIjjAofdlZfhAAAATnRSTlMAcNMuA1dbICV2E9/pJwL8nn0i/tb7za7Ezkrn8uwr+ODoxf2bfhVjZPZNpgpg21McUoAtAUO6hDLC9wiNHWEeEsliyCPzBXe+nHSFyoe2/a9bAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAA50lEQVR42k2R53bCMAyFLxBI2HuPQMJuCy3QPWiZnXr/x6lsJ3H05159R8eyJECGVWy07YEzsqAjVciTCnc49mEsTTr6PQXNjE+O50+irilgrhnU7XDaE9UMptMA1jlrsV6xRgO65GzLWgGyutHiAXgVpoR4qP89cCM0gaSG1WugLkwEEU1XwLosTBIJRZ6I7gxsHmUSR0nqx3Pr4hL+c1mgwtI5yClvqxJG2b6xfks4n6nSCXuDJ/5hfX8pK1jLye10iX7/vjreTzKmWlqvH5okHfMXPB66HssXUqFrWCNnYLcbRe9C/zSHSoQULJqsAAAAAElFTkSuQmCC",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"21\" height=\"20\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 21 20\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAA7VBMVEVMaXHkAonjAofjBov/VarlA4rmA4nnCIfjB4rlAojkDZTkAojkAojlB4n/gP/kAojkA4jkAonpCIfkAojkAojkAofkAojjA4jkA4fkAojjA4rjAojkAojkAofnBojjAojkAofkAofkA4jkAofjA4nlAojnDJLlA4nmA4fjAojlA4jjA4fmGpnkA4fjAofjA4fkCYnjA4njBIfoBoj////kBInkA4jkBIfmBYrjA4fjAof/IJ/kBIjlCY3lA4nmCYjxDo7jA4jlA4fkA4fpB4rkAof/M5njAofkA4jjA4jlAojkBIjjA4flBIjjAofdlZfhAAAATnRSTlMAcNMuA1dbICV2E9/pJwL8nn0i/tb7za7Ezkrn8uwr+ODoxf2bfhVjZPZNpgpg21McUoAtAUO6hDLC9wiNHWEeEsliyCPzBXe+nHSFyoe2/a9bAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAA50lEQVR42k2R53bCMAyFLxBI2HuPQMJuCy3QPWiZnXr/x6lsJ3H05159R8eyJECGVWy07YEzsqAjVciTCnc49mEsTTr6PQXNjE+O50+irilgrhnU7XDaE9UMptMA1jlrsV6xRgO65GzLWgGyutHiAXgVpoR4qP89cCM0gaSG1WugLkwEEU1XwLosTBIJRZ6I7gxsHmUSR0nqx3Pr4hL+c1mgwtI5yClvqxJG2b6xfks4n6nSCXuDJ/5hfX8pK1jLye10iX7/vjreTzKmWlqvH5okHfMXPB66HssXUqFrWCNnYLcbRe9C/zSHSoQULJqsAAAAAElFTkSuQmCC\" width=\"21\" height=\"20\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAA7VBMVEVMaXHkAonjAofjBov/VarlA4rmA4nnCIfjB4rlAojkDZTkAojkAojlB4n/gP/kAojkA4jkAonpCIfkAojkAojkAofkAojjA4jkA4fkAojjA4rjAojkAojkAofnBojjAojkAofkAofkA4jkAofjA4nlAojnDJLlA4nmA4fjAojlA4jjA4fmGpnkA4fjAofjA4fkCYnjA4njBIfoBoj////kBInkA4jkBIfmBYrjA4fjAof/IJ/kBIjlCY3lA4nmCYjxDo7jA4jlA4fkA4fpB4rkAof/M5njAofkA4jjA4jlAojkBIjjA4flBIjjAofdlZfhAAAATnRSTlMAcNMuA1dbICV2E9/pJwL8nn0i/tb7za7Ezkrn8uwr+ODoxf2bfhVjZPZNpgpg21McUoAtAUO6hDLC9wiNHWEeEsliyCPzBXe+nHSFyoe2/a9bAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAA50lEQVR42k2R53bCMAyFLxBI2HuPQMJuCy3QPWiZnXr/x6lsJ3H05159R8eyJECGVWy07YEzsqAjVciTCnc49mEsTTr6PQXNjE+O50+irilgrhnU7XDaE9UMptMA1jlrsV6xRgO65GzLWgGyutHiAXgVpoR4qP89cCM0gaSG1WugLkwEEU1XwLosTBIJRZ6I7gxsHmUSR0nqx3Pr4hL+c1mgwtI5yClvqxJG2b6xfks4n6nSCXuDJ/5hfX8pK1jLye10iX7/vjreTzKmWlqvH5okHfMXPB66HssXUqFrWCNnYLcbRe9C/zSHSoQULJqsAAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/call-icon.563b66aa59f1e526896fc40759c3d849.svg"),
        {
          React: SvgCallIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      